module.exports = __webpack_public_path__ + "img/driverLocBan.c0e2cc44.svg";